import React, { useRef, useState } from "react";

import styles from "./Fieldset.module.css";
import Popup from "./Popup";

type FieldSetContext = {
  close: () => void;
};

interface Props {
  title: string;
  value?: string;
  centerPopup?: boolean;
  children: (args: FieldSetContext) => React.ReactNode;
}

const FieldSet = ({ title, value = "Any", centerPopup, children }: Props) => {
  const [open, setOpen] = useState(false);
  const fieldsetRef = useRef<HTMLDivElement>(null);

  const close = () => setOpen(false);

  return (
    <div ref={fieldsetRef} className={styles.fieldset} data-open={open}>
      <button
        type="button"
        data-component="fieldset-button"
        data-open={open}
        onClick={() => setOpen(true)}
      >
        <span data-component="label">{title}</span>
        <span>{value}</span>
      </button>

      <Popup
        anchorEl={fieldsetRef}
        title={title}
        open={open}
        centerPopup={centerPopup}
        close={close}
      >
        {children({ close })}
      </Popup>
    </div>
  );
};

export default FieldSet;
